import React from 'react';
import './home.css';
import './recharge.css';
import { useNavigate, useLocation } from 'react-router-dom';
import eliteGem from '../../Assets/images/elite.png';   // Replace with your actual path
import expertGem from '../../Assets/images/mast.png'; // Replace with your actual path
import masterGem from '../../Assets/images/master.png'; // Replace with your actual path
import GameHeader from '../header/header';

const UpgradeUserLevel = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const item = location.state;

    const levels = [
        {
            id: 1,
            title: "ELITE",
            fee: "500 USDC",
            benefits: [
                "50 Games with commissions ranging from 2.0% to 6.0%",
                "Additional reward: 10% of the upgrade fee (50 USDC)"
            ],
            color: "#0D6EFD",
            image: eliteGem
        },
        {
            id: 2,
            title: "EXPERT",
            fee: "1,000 USDC",
            benefits: [
                "70 Games with commissions ranging from 3.0% to 9.0%",
                "Additional reward: 15% of the upgrade fee (150 USDC)"
            ],
            color: "#FF00FF",
            image: expertGem
        },
        {
            id: 3,
            title: "MASTER",
            fee: "2,000 USDC",
            benefits: [
                "100 Games with commissions ranging from 4.0% to 12.0%",
                "Additional reward: 20% of the upgrade fee (400 USDC)"
            ],
            color: "#0D6EFD",
            image: masterGem
        }
    ];

    return (
        <div className="obtibg">
            <GameHeader />
            <div className="upgrade-page">
                <div className="upgrade-header">
                    <h1>Epic Games <span>Membership Upgrade</span></h1>
                    <p>
                        Elevate your membership to access exclusive benefits and enhance your optimization experience.
                        Select from three premium tiers: Elite, Expert, Master.
                    </p>
                </div>

                <div className="level-list">
                    {levels.map((level, idx) => (
                        <div className="level-box" key={idx}>
                            <div className="level-header" style={{ backgroundColor: level.bgColor }}>
                                <div className="level-number">{level.number}</div>
                                <img src={level.image} alt={level.title} className="level-gem" />
                                <div className="level-title">{level.title}</div>
                                <div className="level-fee">{level.fee}</div>
                            </div>
                            <div className="level-benefits">
                                {level.benefits.map((b, i) => (
                                    <p key={i}>{b}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="upgrade-note">
                    <p>
                        The upgrade funds will be credited directly to your platform account. Once you have optimized all the gaming software for the corresponding agent level, you can withdraw all the funds.
                    </p>
                    <p className="pink-note">
                        The additional reward is only available once per account.
                    </p>
                    {/* Add your gamepad image if available */}
                    {/* <img src={gamepad} alt="Gamepad" className="gamepad-img" /> */}
                </div>
            </div>
        </div>
    );
};

export default UpgradeUserLevel;
